/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { VideoProviderConfigModel } from "./VideoProviderConfigModel";
